var path = 'scripts/views/components/transaction-link-icon.html';
var html = "<span class=\"fa fa-link has-tpd third-party-data-icon\"\n      ng-click=\"$ctrl.goToThirdPartyData()\"\n      ng-class=\"$ctrl.isLinked() ? ['success-font'] : ['light-font']\"\n      tooltip-class=\"tooltip-bring-to-front transaction-link-tooltip\"\n      tooltip-append-to-body=\"true\"\n      uib-tooltip=\"{{ $ctrl.getLinkToolTip() | translate }}\"\n></span>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/transaction-link-icon.html
// module id = 355
// module chunks = 0